var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsLineDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.369 1)",
    stroke: "#410062",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M0 6.5h20M34 6.5h20"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.631,
    cy: 6,
    r: 6
  }))));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTdweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgNTcgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+QkM0OTg4M0MtRjg3QS00NkY5LTkyQkUtQUY0OTQzMEJBMTNFPC90aXRsZT4KICAgIDxnIGlkPSJDdXN0b21lcnMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSIwM18wNV9Tb2xkaVZhdWx0X0N1c3RvbWVyX1RyYW5zYWN0aW9ucyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTczOC4wMDAwMDAsIC04NzEuMDAwMDAwKSIgc3Ryb2tlPSIjNDEwMDYyIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzM5LjM2ODg1MiwgODcyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjAiIHkxPSI2LjUiIHgyPSIyMCIgeTI9IjYuNSIgaWQ9IkxpbmUtMyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+PC9saW5lPgogICAgICAgICAgICAgICAgPGxpbmUgeDE9IjM0IiB5MT0iNi41IiB4Mj0iNTQiIHkyPSI2LjUiIGlkPSJMaW5lLTMtQ29weSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+PC9saW5lPgogICAgICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgY3g9IjI3LjYzMTE0NzUiIGN5PSI2IiByPSI2Ij48L2NpcmNsZT4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgIconsLineDot as ReactComponent };